import { LOGOUT } from './auth.type';

export const logout = () => ({
  type: LOGOUT,
});
